var map = {
	"./23.json": "M6V0"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "INrC";


//////////////////
// WEBPACK FOOTER
// ./src/components/homechart/mapJSON/geometryProvince ^\.\/.*\.json$
// module id = INrC
// module chunks = 183